import { Theme } from '@mui/material';
import { InventoryItem, InventoryStatus } from 'common/modules/inventory';
import { TagProps } from 'components/Tag';
import type { TFunction } from 'i18next';

export const getStatusHighlightColor = (status: InventoryStatus, theme: Theme) => {
	switch (status) {
		case 'IN_USE':
			return theme.palette.colors.availabilityGood.light;
		case 'OUT_OF_USE':
			return theme.palette.colors.availabilityNone.light;
		default:
			return theme.palette.background.secondary;
	}
};

export const getArticleTags = (item: InventoryItem, t: TFunction) => {
	const tags: TagProps[] = [];
	if (!!item.activeOrderIds?.length) {
		tags.push({
			text: 'Out',
			tooltip: t('inventory.article.status.outDescription', 'Article is part of an active order'),
			color: 'primary',
		});
	} else {
		tags.push({
			text: 'In',
			tooltip: t('inventory.article.status.inDescription', 'Article is currently in inventory'),
			color: 'primary',
		});
	}
	return tags;
};
